module.exports = __webpack_public_path__ + "img/ballantines-first-block-img-mobile.74699436.png";